<div class="animated fadeInRight">
  <!-- MENU DE TITULOS -->
  <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit"
    [modulo]="DAT_TITULOS.modulo" [tituloCard]="DAT_TITULOS.titulo" [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <!-- MENU DE TITULOS -->

  <!-- OPCIONES LATERAL IZQUIERDO -->
  <ng-template #innTemplateButton>
    <div class="col-md-6 mb-2">
      <div class="pagetitle">
        <div class="btn-group-justified btn-group" style="float: right;">
          <button (click)="nuevo()" class="btn btn-outline-success">
            <i aria-hidden="true" class="fa fa-plus"></i>
            AGREGAR NUEVO
          </button>
        </div>
      </div>
    </div>
  </ng-template>
  <!-- OPCIONES LATERAL IZQUIERDO -->

  <!-- GRILLA -->
  <ng-template #enviarTemplateEdit>
    <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
    <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [class]="DAT_AG_GRID.class" [columnDefs]="columnDefs"
      [floatingFilter]="true" [frameworkComponents]="frameworkComponents" [id]="DAT_AG_GRID.id"
      [ngStyle]="DAT_AG_GRID.style" [paginationPageSize]="DAT_AG_GRID.paginacion" [pagination]="true"
      [rowData]="rowData">
    </ag-grid-angular>
  </ng-template>
  <!-- GRILLA -->
</div>

<!-- MODAL -->
<app-lfsa-modal [classModal]="'modal-lg'" [idButton]="'abrirModalAregarTicket'" [idClose]="'cerrarModalAgregarTicket'"
  [innTemplate]="abrirModalAgregarTicketTransporte" [titulo]="tituloModal"></app-lfsa-modal>
  
<ng-template #abrirModalAgregarTicketTransporte>
  <div class="container-fluid">
    <form [formGroup]="mantenerTanquerosForm" class="row">

      <div class="col-lg-6 mb-2">
        <label for="identTanquero">ID DEL SISTEMA</label>
        <input class="form-control" formControlName="identTanquero" name="identTanquero"
          type="text">
        <small *ngIf="mantenerTanquerosForm.get('identTanquero')?.hasError('required')"
          class="text-danger">*Este campo es requerido</small>
      </div>

      <div class="col-lg-6 mb-2">
        <label for="garitaAsignadaDescripcion">NÚMERO INTERNO DE CONTROL</label>
        <input class="form-control" formControlName="numeroControl"  id="numeroControl" name="numeroControl" type="number">
        <small *ngIf="mantenerTanquerosForm.get('garitaAsignada')?.hasError('required')"
          class="text-danger">*Este campo es requerido</small>
      </div>

      <div class="col-lg-12 mb-2">
        <div class="row">
          <div class="col-lg-3">
            <label for="proveedor_RUC">RUC Proveedor transporte</label>
            <input class="form-control" formControlName="proveedor_RUC" id="proveedor_RUC" name="proveedor_RUC" type="text">
            <div
              *ngIf="mantenerTanquerosForm.controls['proveedor_RUC'].invalid && (mantenerTanquerosForm.controls['proveedor_RUC'].dirty || mantenerTanquerosForm.controls['proveedor_RUC'].touched)"
              class="text-danger">
              <small>
                <div *ngIf="mantenerTanquerosForm.controls['proveedor_RUC'].errors"> El campo es requerido. </div>
              </small>
            </div>
          </div>
          <div class="col-lg-1 ps-0">
            <button (click)="onChangeProveedorTransporte($event)"
              [disabled]="mantenerTanquerosForm.controls['proveedor_RUC'].errors"
              class="btn btn-success mt-4">Buscar
            </button>
          </div>
          <div class="col-lg-8">
            <label for="proveedor_DET">Detalle Proveedor Transporte</label>
            <input class="form-control" formControlName="proveedor_DET" id="proveedor_DET" readonly type="text">
          </div>
        </div>
      </div>

      <div class="col-lg-12 mb-2">
        <div class="row">
          <div class="col-lg-3">
            <label for="tanqueroPlaca">Tanquero Placa</label>
            <input class="form-control" formControlName="tanqueroPlaca" id="tanqueroPlaca" name="tanqueroPlaca" type="text">
            <div
              *ngIf="mantenerTanquerosForm.controls['tanqueroPlaca'].invalid && (mantenerTanquerosForm.controls['tanqueroPlaca'].dirty || mantenerTanquerosForm.controls['tanqueroPlaca'].touched)"
              class="text-danger">
              <small>
                <div *ngIf="mantenerTanquerosForm.controls['tanqueroPlaca'].errors">
                  El campo es requerido.
                </div>
              </small>
            </div>
          </div>

          <div class="col-lg-1 ps-0">
            <button (click)="buscarPlacaTransporte()"
              [disabled]="mantenerTanquerosForm.controls['tanqueroPlaca'].errors" class="btn btn-success mt-4">Buscar
            </button>
          </div>

          <div class="col-lg-8">
            <div class="row">              
              <div class="form-group col-4">
                <label for="tanqueroPlacaTransportista">Vehículo</label>
                <input class="form-control" formControlName="tanqueroTipo" id="tanqueroTipo" name="tanqueroTipo" readonly
                  type="text">
              </div>

              <div class="form-group col-4">
                <label for="tanqueroPlacaTransportista">Marca</label>
                <input class="form-control" formControlName="tanqueroMarca" id="tanqueroMarca" name="tanqueroMarca" readonly type="text">
              </div>

              <div class="form-group col-4">
                <label for="tanqueroPlacaTransportista">Modelo</label>
                <input class="form-control" formControlName="tanqueroModelo" id="tanqueroModelo" name="tanqueroModelo" readonly type="text">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12 mb-2">
        <div class="row">
          <div class="col-lg-3">
            <label for="chofer">Cedula chofer</label>
            <input class="form-control" formControlName="choferNCedula" id="choferNCedula" name="choferNCedula" type="text">
            <div
              *ngIf="mantenerTanquerosForm.controls['choferNCedula'].invalid && (mantenerTanquerosForm.controls['choferNCedula'].dirty || mantenerTanquerosForm.controls['choferNCedula'].touched)"
              class="text-danger">
              <small>
                <div *ngIf="mantenerTanquerosForm.controls['choferNCedula'].errors">
                  Formato inválido.
                </div>
              </small>
            </div>
          </div>
          
          <div class="col-lg-1 ps-0">
            <button (click)="buscarCedulaChofer()"
              [disabled]="mantenerTanquerosForm.controls['choferNCedula'].errors"
              class="btn btn-success mt-4">Buscar
            </button>
          </div>

          <div class="col-lg-5">
            <label for="detTransporte">Apellidos y Nombres</label>
            <input class="form-control" formControlName="choferNombres" id="choferNombres" readonly type="text">
          </div>

          <div class="col-lg-3">
            <label for="detTransporte">Celular</label>
            <input class="form-control" formControlName="choferCelular" id="choferCelular" readonly type="text">
          </div>
        </div>
      </div>

      <div class="col-lg-4 mb-2">
        <label for="referenciaPro">Referencia Productos</label>
        <input class="form-control" formControlName="referenciaPro" name="referenciaPro" />
        <small *ngIf="mantenerTanquerosForm.get('referenciaPro')?.hasError('required')"
          class="text-danger">*Este campo es requerido</small>
        <small *ngIf="mantenerTanquerosForm.get('referenciaPro')?.hasError('maxlength')"
          class="text-danger">*Máximo 50 caracteres</small>
      </div>

      <div class="col-lg-4 mb-2">
        <label for="lugarSalida">Lugar Salida</label>
        <input class="form-control" formControlName="lugarSalida" name="lugarSalida" />
        <small *ngIf="mantenerTanquerosForm.get('lugarSalida')?.hasError('required')"
          class="text-danger">*Este campo es requerido</small>
        <small *ngIf="mantenerTanquerosForm.get('lugarSalida')?.hasError('maxlength')"
          class="text-danger">*Máximo 50 caracteres</small>
      </div>

      <div class="col-lg-4 mb-2">
        <label for="lugarLlegada">Lugar Llegada</label>
        <input class="form-control" formControlName="lugarLlegada" name="lugarLlegada" />
        <small *ngIf="mantenerTanquerosForm.get('lugarLlegada')?.hasError('required')"
          class="text-danger">*Este campo es requerido</small>
        <small *ngIf="mantenerTanquerosForm.get('lugarLlegada')?.hasError('maxlength')"
          class="text-danger">*Máximo 50 caracteres</small>
      </div>

      <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )"
        [formularioValido]="mantenerTanquerosForm.invalid" [loading]="loading" [textBoton]="'Guardar'" class="row">
      </app-lfsa-botones-formulario>

    </form>
  </div>

</ng-template>
<!-- END MODAL -->